module.exports = __webpack_public_path__ + "fonts/NoirPro-Medium.04b5d842.woff";